import { useState } from "react";
import authService from "../config";
import { useNavigate } from "react-router-dom";

export default function VerifyOTP({ showNotification, onLoginSuccess, onClose }) {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const otpSession = JSON.parse(localStorage.getItem("otpSession"));

  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (!otp) {
      showNotification("warning", "Please enter OTP");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        email: otpSession?.email,
        // mobile: otpSession?.mobile, // optional
        otp
      };

      const response = await authService.verifyLoginOTP(payload);

      showNotification("success", "OTP verified successfully");

      // Save user data
      localStorage.setItem(
        "userData",
        JSON.stringify({
          name: response.name,
          email: response.email,
          user_role: response.user_role,
          default_project: response.default_project,
          project_category: response.project_category
        })
      );

      localStorage.removeItem("otpSession");

      setTimeout(() => {
        if (onLoginSuccess) {
          onLoginSuccess();
        } else {
          navigate("/dashboard");
          if (onClose) onClose();
        }
      }, 1000);
    } catch (err) {
      showNotification(
        "error",
        err.message || "Invalid OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleVerifyOTP} className="space-y-4">
      <h2 className="text-xl font-bold text-center">Verify OTP</h2>

      <input
        type="text"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Enter OTP"
        className="w-full border rounded-md px-3 py-2"
      />

      <button
        type="submit"
        disabled={loading}
        className="w-full bg-blue-600 text-white py-2 rounded-md"
      >
        {loading ? "Verifying..." : "Verify OTP"}
      </button>
    </form>
  );
}
